import React from "react";
import { notFoundImage } from "../../assets";

const NotFoundPlaceHolder = ({
  title = "",
  description = "",
  placeHolderImage = notFoundImage,
  className = "",
}) => {
  return (
    <div className={`content_placeholder ${className}`}>
      <img
        src={placeHolderImage}
        alt={`${title} place holder`}
        loading="lazy"
      />
      <h3>{title}</h3>
      {description && <p>{description}</p>}
    </div>
  );
};

export default NotFoundPlaceHolder;
